import type { FC } from 'react';

import { useMaintainCustomer } from './services/useMaintainCustomer';
import { useMaintainNotifications } from './services/useMaintainNotifications';

export const BackendDataUpdater: FC = () => {
  const refreshCustomer = useMaintainCustomer();
  useMaintainNotifications(refreshCustomer);

  return null;
};
